import request from "./request";

/**
 * 获取微信 JS-API 配置
 */
export function getJsapiConfig(params = {}) {
  return request({
    url: "/mp/user/getJsapiConfig",
    method: "get",
    params,
  });
}

export * from "./order";
export * from "./login";
export * from "./user";
export * from "./file";
